export const getDocument = (state, id) => state.document.documents.entries[id];
